// extracted by mini-css-extract-plugin
export var leftAlign = "_33-2";
export var popper = "_33-0";
export var subtitle = "_33-1";